import React from 'react';
import { Squish, Typography } from '@grubhubprod/gh-cookbook-react';

export const PaginationEllipsis: React.FC = () => {
  return (
    <Squish inset="x-sm">
      <Typography color="secondaryText" aria-hidden="true">
        …
      </Typography>
    </Squish>
  );
};
